import { trigger_interaction } from './Analytics';




export function selectSubQuestion({ questionId, subQuestionId }) {
    trigger_interaction('HOME', 'o', `SUBQ, ${questionId}, ${subQuestionId}`);
}
export function selectQCardSubTopic({ topicId, subTopicId }) {
    trigger_interaction('HOME', 'o', `QCARD, SUBTOPIC, ${topicId}, ${subTopicId}`);
}
export function selectTable() {
    trigger_interaction('HOME', 'o', 'TABLE');
}
export function selectMap() {
    trigger_interaction('HOME', 'o', 'MAP');
}
export function selectGraph() {
    trigger_interaction('HOME', 'o', 'GRAPH');
}


